import iziToast from 'izitoast'
import _ from 'lodash'
import route from 'vue-router'
import utils from '../../utils/index'

const state = {
}

const mutations = {
    SHOW(state, payload){
        if(typeof payload !== 'undefined' && (!payload.hasOwnProperty('type') || payload.type === 'success')){
            iziToast.success({
                title: 'Sucesso',
                message: (typeof payload !== 'undefined' && typeof payload.message !== 'undefined') ? payload.message : 'Operação realizada com sucesso!'
            });
        }
        else if(typeof payload !== 'undefined' && (!payload.hasOwnProperty('type') || payload.type === 'warning')){
            iziToast.warning({
                title: 'Ops',
                message: (typeof payload !== 'undefined' && typeof payload.message !== 'undefined') ? payload.message : 'Algo aconteceu aqui...'
            });
        }
        else {
            iziToast.error({
                title: 'Erro',
                message: (typeof payload !== 'undefined' && typeof payload.message !== 'undefined') ? payload.message : 'Houve um erro.'
            });
        }
    },
    SHOW_ERROR(state, error){
        const errors = error.errors;
        if(typeof errors !== 'undefined' && _.keys(errors.length > 0)){
            iziToast.error({
                title: 'Erro',
                message: errors[_.keys(errors).find(e => !!e)].message
            });
            return true;
        }
        if(_.has(error,'body')){
            iziToast.error({
                title: error.body.code,
                message: error.body.message
            });
            return true;
        }
        if(error){
            iziToast.error({
                title: 'Ops...',
                message: error
            });
        }
        else {
            iziToast.error({
                title: 'Ops...',
                message: "Ocorreu um erro."
            });
        }
    },
    /**
     * 
     * @param {*} state 
     * @param {*} data // http://izitoast.marcelodolza.com/ documentation notification 
     */
    SHOW_NOTIFICATION(state, payload) {
        let options = {
            theme: 'dark',
            layout: 2,
            position: 'topCenter',
            title: 'hey',
            progressBarColor: '#58BFC6',
            ...payload.options
        }

        let data = {}
        if(payload.user) payload.user = utils.toTitleizeString(payload.user)
        if(payload.type === 'system-update')
            data = {
                ...options,
                backgroundColor: '#4D76C8',
                message: `Uma nova versão ${payload.version} está disponível :D`,
                timeout: false,
                close: false,
                drag: false,
                progressBar: false,
                displayMode: 2,
                targetFirst: false,
                buttons: [
                    [
                      '<button>Atualizar</button>',
                      function (instance, toast) {
                          if(payload.update){
                              payload.update()
                          }
                      }
                    ]
                ]
            }
        else if(payload.type === 'available')  
            data = {
                ...options,
                title: 'on',
                class: 'available',
                titleColor: '#55e91a',
                message: `${payload.user} ficou disponível.`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3500,
                buttons: payload.hasOwnProperty('focusOnMap') 
                    ? [[
                        '<button>Ver no mapa</button>',
                        function(instance, toast) {
                            if(payload.focusOnMap) {
                                payload.focusOnMap()
                            }
                        }
                    ]] 
                    : null
            }
        else if(payload.type === 'unavailable')  
            data = {
                ...options,
                title: 'off',
                class: 'available',
                titleColor: '#e9361a',
                message: `${payload.user} ficou indisponível.`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3000
            }
        else if(payload.type === 'request-created')
            data = {
                ...options,
                titleColor: '#55e91a',
                message: `Novo pedido ${payload.isZepplin ? 'Zepplin' : ''} #${payload.requestId}`, 
                timeout: 3000
            }
        else if(payload.type === 'request-finished')  
            data = {
                ...options,
                class: 'available',
                titleColor: '#55e91a',
                message: `${payload.user} finalizou o pedido #${payload.requestId}.`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3000
            }
        else if(payload.type === 'request-canceled')  
            data = {
                ...options,
                class: 'available',
                titleColor: '#e9361a',
                message: `${payload.user} cancelou o pedido #${payload.requestId}`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3000
            }
        else if(payload.type === 'request-removed')  
            data = {
                ...options,
                class: 'available',
                titleColor: '#e9361a',
                message: `${payload.user} removeu o pedido #${payload.requestId}`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3000
            }
        else if(payload.type === 'request-chat')
            data = {
                ...options,
                class: 'available', 
                title: `#${payload.requestId}`,
                message: `${payload.user}: ${payload.message}`,
                image: payload.avatarUrl,
                imageWidth: 80,
                timeout: 3000,
                balloon: true,
                buttons: [
                    [
                        '<button>Abrir chat</button>',
                        function (instance, toast) {
                            if(payload.openRequestChat){
                                payload.openRequestChat()
                                instance.hide({ transitionOut: 'fadeOutUp' }, toast)
                            }
                        }
                    ]
                ]
            }
        else data = options

        iziToast.show(data)
    }
}

const actions = {
    showToast(context, payload){
        context.commit('SHOW',payload);
    },
    showError(context, errorDetailed){
        context.commit('SHOW_ERROR', errorDetailed);
    },
    showNotification(context, payload) {
        context.commit('SHOW_NOTIFICATION', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
